import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'
import { getStorage } from 'firebase/storage'
import { getAuth } from 'firebase/auth'
import * as firebaseui from 'firebaseui'

const firebaseConfig = {
  apiKey: 'AIzaSyAh4PSl1mOAcbn5-p70UMF-SEgANand1pM',
  authDomain: 'api-project-169482247761.firebaseapp.com',
  databaseURL: 'https://api-project-169482247761.firebaseio.com',
  projectId: 'api-project-169482247761',
  storageBucket: 'api-project-169482247761.appspot.com',
  messagingSenderId: '169482247761',
  appId: '1:169482247761:web:13cf7ee64656ee985ca270',
  measurementId: 'G-CV1S5VJPEY',
}

const app = initializeApp(firebaseConfig)
const db = getDatabase(app)
const storage = getStorage(app)
const auth = getAuth(app)
const authUi = new firebaseui.auth.AuthUI(auth)

// Direct public download URL for a Storage object. The bucket allows public reads, so we
// can build the `?alt=media` URL ourselves and let an <img> tag load it — this avoids the
// authenticated getDownloadURL() XHR, which fails from the browser (CORS on the metadata
// endpoint). A non-existent object simply 404s and the caller shows its fallback.
const storageThumbUrl = (path) =>
  `https://firebasestorage.googleapis.com/v0/b/${firebaseConfig.storageBucket}/o/${encodeURIComponent(
    path
  )}?alt=media`

export { db, storage, auth, authUi, storageThumbUrl }
